<template>
  <div class="editor-header-report-button__wrapper">
    <aha-button
      :variant="'base'"
      @click="$emit('showExport')"
      v-tooltip="$i18nPresenter.t('View report & export to Excel')"
      class="editor-header-report-button"
    >
      <aha-icon
        name="bar-chart-square"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      />
    </aha-button>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.editor-header-report-button__wrapper {
  @apply flex items-center;
  @media screen and (max-width: 639px){
    @apply mr-1;
  }
}
.editor-header-report-button {
  @apply py-2 px-0 mb-1;
  min-width: 39px;
}
</style>
